import { useQuery } from '@tanstack/react-query';

import Service from '@/lib/App';

export const useGetGrabAreaGeoJson = (areaID?: number) =>
  useQuery({
    queryKey: ['getGrabAreaGeoJson', areaID],
    queryFn: () =>
      Service.grabAreaManagement.getGrabAreaGeoJson({
        areaID,
      }),
    enabled: !!areaID,
  });

export const useBatchSearchGrabAreas = (areaIDs: number[]) => {
  const sortedAreaIDs = areaIDs.sort((a, b) => a - b);
  return useQuery({
    queryKey: ['batchSearchGrabAreas', sortedAreaIDs],
    queryFn: () =>
      Service.grabAreaManagement.batchSearchGrabArea({
        areaIDs,
        limit: areaIDs.length,
      }),
    enabled: !!areaIDs.length,
  });
};
